import {EditorToolType} from './EditorToolType';
import {FloatPosition} from './FloatPosition';
import {EditorToolDefinition} from '../types';

/**
 * Předdefinovaný nástroj mapového editoru.
 */
enum EditorTool {
    /**
     * Nástroj typu {@link EditorToolType.POINT}.
     */
    POINT = 'POINT',

    /**
     * Nástroj typu {@link EditorToolType.POINT_COORDS}.
     */
    POINT_COORDS = 'POINT_COORDS',

    /**
     * Nástroj typu {@link EditorToolType.LINE}.
     */
    LINE = 'LINE',

    /**
     * Nástroj typu {@link EditorToolType.LINE_COORDS}.
     */
    LINE_COORDS = 'LINE_COORDS',

    /**
     * Nástroj typu {@link EditorToolType.LINE_OFFSET}.
     */
    LINE_OFFSET = 'LINE_OFFSET',

    /**
     * Nástroj typu {@link EditorToolType.LINE_PARTIAL_OFFSET}.
     */
    LINE_PARTIAL_OFFSET = 'LINE_PARTIAL_OFFSET',

    /**
     * Nástroj typu {@link EditorToolType.LINE_EXTENSION}.
     */
    LINE_EXTENSION = 'LINE_EXTENSION',

    /**
     * Nástroj typu {@link EditorToolType.POLYGON}.
     */
    POLYGON = 'POLYGON',

    /**
     * Nástroj typu {@link EditorToolType.POLYGON_COORDS}.
     */
    POLYGON_COORDS = 'POLYGON_COORDS',

    /**
     * Nástroj typu {@link EditorToolType.FIXED_RECTANGLE}.
     */
    FIXED_RECTANGLE = 'FIXED_RECTANGLE',

    /**
     * Nástroj typu {@link EditorToolType.MEASURE_LINE}.
     */
    MEASURE_LINE = 'MEASURE_LINE',

    /**
     * Nástroj typu {@link EditorToolType.MEASURE_POLYGON}.
     */
    MEASURE_POLYGON = 'MEASURE_POLYGON',

    /**
     * Nástroj typu {@link EditorToolType.CIRCLE}.
     */
    CIRCLE = 'CIRCLE',

    /**
     * Nástroj typu {@link EditorToolType.CIRCLE_RADIUS}.
     */
    CIRCLE_RADIUS = 'CIRCLE_RADIUS',

    /**
     * Nástroj typu {@link EditorToolType.CIRCLE_COORDS}.
     */
    CIRCLE_COORDS = 'CIRCLE_COORDS',

    /**
     * Nástroj typu {@link EditorToolType.GUIDED_LINE}.
     */
    GUIDED_LINE = 'GUIDED_LINE',

    /**
     * Nástroj typu {@link EditorToolType.PERPENDICULAR_LINE}.
     */
    PERPENDICULAR_LINE = 'PERPENDICULAR_LINE',

    /**
     * Nástroj typu {@link EditorToolType.GUIDED_POLYGON}.
     */
    GUIDED_POLYGON = 'GUIDED_POLYGON',

    /**
     * Nástroj typu {@link EditorToolType.SELECT}.
     */
    SELECT = 'SELECT',

    /**
     * Nástroj typu {@link EditorToolType.EXACT_SELECT}.
     */
    EXACT_SELECT = 'EXACT_SELECT',

    /**
     * Nástroj typu {@link EditorToolType.EXACT_SINGLE_SELECT}.
     */
    EXACT_SINGLE_SELECT = 'EXACT_SINGLE_SELECT',

    /**
     * Nástroj typu {@link EditorToolType.BOX_SELECT}.
     */
    BOX_SELECT = 'BOX_SELECT',

    /**
     * Nástroj typu {@link EditorToolType.LINE_SELECT}.
     */
    LINE_SELECT = 'LINE_SELECT',

    /**
     * Nástroj typu {@link EditorToolType.POLY_SELECT}.
     */
    POLY_SELECT = 'POLY_SELECT',

    /**
     * Nástroj typu {@link EditorToolType.POLY_SELECT_INTERSECT}.
     */
    POLY_SELECT_INTERSECT = 'POLY_SELECT_INTERSECT',

    /**
     * Nástroj typu {@link EditorToolType.CIRCLE_SELECT}.
     */
    CIRCLE_SELECT = 'CIRCLE_SELECT',

    /**
     * Nástroj typu {@link EditorToolType.BOX_ZOOM}.
     */
    BOX_ZOOM = 'BOX_ZOOM',

    /**
     * Nástroj typu {@link EditorToolType.MOVE}.
     */
    MOVE = 'MOVE',

    /**
     * Nástroj typu {@link EditorToolType.EDIT}.
     */
    EDIT = 'EDIT',

    /**
     * Nástroj typu {@link EditorToolType.EDIT_MOVE}.
     */
    EDIT_MOVE = 'EDIT_MOVE',

    /**
     * Nástroj typu {@link EditorToolType.ROTATE}.
     */
    ROTATE = 'ROTATE',

    /**
     * Nástroj typu {@link EditorToolType.ROTATE_MOVE}.
     */
    ROTATE_MOVE = 'ROTATE_MOVE',

    /**
     * Nástroj typu {@link EditorToolType.CUT}.
     */
    CUT = 'CUT',

    /**
     * Nástroj typu {@link EditorToolType.COPY}.
     */
    COPY = 'COPY',

    /**
     * Nástroj typu {@link EditorToolType.COPY_TO_CLIPBOARD }.
     */
    COPY_TO_CLIPBOARD = 'COPY_TO_CLIPBOARD',

    /**
     * Nástroj typu {@link EditorToolType.PASTE}.
     */
    PASTE = 'PASTE',

    /**
     * Nástroj typu {@link EditorToolType.DELETE}.
     */
    DELETE = 'DELETE',

    /**
     * Nástroj typu {@link EditorToolType.DUPLICATE}.
     */
    DUPLICATE = 'DUPLICATE',

    /**
     * Nástroj typu {@link EditorToolType.MERGE}.
     */
    MERGE = 'MERGE',

    /**
     * Nástroj typu {@link EditorToolType.MERGE_LINES}.
     */
    MERGE_LINES = 'MERGE_LINES',

    /**
     * Nástroj typu {@link EditorToolType.SPLIT}.
     */
    SPLIT = 'SPLIT',

    /**
     * Nástroj typu {@link EditorToolType.SPLIT_LINE}.
     */
    SPLIT_LINE = 'SPLIT_LINE',

    /**
     * Nástroj typu {@link EditorToolType.SPLIT_POLYGON}.
     */
    SPLIT_POLYGON = 'SPLIT_POLYGON',

    /**
     * Nástroj typu {@link EditorToolType.OFFSET}.
     */
    OFFSET = 'OFFSET',

    /**
     * Nástroj typu {@link EditorToolType.BUFFER}.
     */
    BUFFER = 'BUFFER',

    /**
     * Nástroj typu {@link EditorToolType.SNAP}.
     */
    SNAP = 'SNAP',

    /**
     * Nástroj typu {@link EditorToolType.TEMP_EDITING}.
     */
    TEMP_EDITING = 'TEMP_EDITING',

    /**
     * Nástroj typu {@link EditorToolType.SHOW_COORDS}.
     */
    SHOW_COORDS = 'SHOW_COORDS',

    /**
     * Nástroj typu {@link EditorToolType.SHOW_LOCATION}.
     */
    SHOW_LOCATION = 'SHOW_LOCATION',

    /**
     * Nástroj typu {@link EditorToolType.SHOW_CONNECTIONS}.
     */
    SHOW_CONNECTIONS = 'SHOW_CONNECTIONS',

    /**
     * Nástroj typu {@link EditorToolType.ORIGIN_LOCATION}.
     */
    ORIGIN_LOCATION = 'ORIGIN_LOCATION',

    /**
     * Nástroj typu {@link EditorToolType.INSPECT}.
     */
    INSPECT = 'INSPECT',

    /**
     * Nástroj typu {@link EditorToolType.PRINT}.
     */
    PRINT = 'PRINT',

    /**
     * Nástroj typu {@link EditorToolType.GEOLOCATION}.
     */
    GEOLOCATION = 'GEOLOCATION',

    /**
     * Nástroj typu {@link EditorToolType.EXPORT_FEATURES}.
     */
    EXPORT_FEATURES = 'EXPORT_FEATURES',

    /**
     * Nástroj typu {@link EditorToolType.EXPORT_LAYERS}.
     */
    EXPORT_LAYERS = 'EXPORT_LAYERS',

    /**
     * Vizuální oddělovač skupin tlačítek nástrojů.
     */
    SEPARATOR = 'SEPARATOR',

    /**
     * Nástroj typu {@link EditorToolType.CUTOUT_DRAW}.
     */
    CUTOUT_DRAW = 'CUTOUT_DRAW',

    /**
     * Nástroj typu {@link EditorToolType.CUTOUT_FIXED_RECTANGLE}.
     */
    CUTOUT_FIXED_RECTANGLE = 'CUTOUT_FIXED_RECTANGLE',

    /**
     * Nástroj typu {@link EditorToolType.CUTOUT_PASTE}.
     */
    CUTOUT_PASTE = 'CUTOUT_PASTE',

    /**
     * Nástroj typu {@link EditorToolType.CUTOUT_FROM_EXISTING}.
     */
    CUTOUT_FROM_EXISTING = 'CUTOUT_FROM_EXISTING',

    /**
     * Nástroj typu {@link EditorToolType.CUTOUT_REMOVE}.
     */
    CUTOUT_REMOVE = 'CUTOUT_REMOVE',

    /**
     * Nástroj typu {@link EditorToolType.ADD_TO_COLLECTION}.
     */
    ADD_TO_COLLECTION = 'ADD_TO_COLLECTION',

    /**
     * Nástroj typu {@link EditorToolType.FROM_COLLECTION}.
     */
    REMOVE_FROM_COLLECTION = 'REMOVE_FROM_COLLECTION',

    /**
     * Nástroj typu {@link EditorToolType.DELETE_FEATURES_GEOMETRY}.
     */
    DELETE_FEATURES_GEOMETRY = 'DELETE_FEATURES_GEOMETRY',

    /**
     * Nástroj typu {@link EditorToolType.MULTI_FIXED_RECTANGLE}.
     */
    MULTI_FIXED_RECTANGLE = 'MULTI_FIXED_RECTANGLE',

    /**
     * Nástroj typu {@link EditorToolType.MULTI_ADD_EXISTING}.
     */
    MULTI_ADD_EXISTING = 'MULTI_ADD_EXISTING',
}

// eslint-disable-next-line
namespace EditorTool {
    /**
     * Vytvoří plovoucí nástroj daného typu - nahoře vlevo.
     *
     * @param type - Typ nástroje.
     * @returns Definice nástroje.
     */
    export function floatTopLeft(type: EditorToolType) {
        return createFloatingTool(type, FloatPosition.TOP_LEFT);
    }

    /**
     * Vytvoří plovoucí nástroj daného typu - nahoře vpravo.
     *
     * @param type - Typ nástroje.
     * @returns Definice nástroje.
     */
    export function floatTopRight(type: EditorToolType) {
        return createFloatingTool(type, FloatPosition.TOP_RIGHT);
    }

    /**
     * Vytvoří plovoucí nástroj daného typu - dole vlevo.
     *
     * @param type - Typ nástroje.
     * @returns Definice nástroje.
     */
    export function floatBottomLeft(type: EditorToolType) {
        return createFloatingTool(type, FloatPosition.BOTTOM_LEFT);
    }

    /**
     * Vytvoří plovoucí nástroj daného typu - dole vpravo.
     *
     * @param type - Typ nástroje.
     * @returns Definice nástroje.
     */
    export function floatBottomRight(type: EditorToolType) {
        return createFloatingTool(type, FloatPosition.BOTTOM_RIGHT);
    }
}

/**
 * Vytvoří plovoucí nástroj daného typu.
 *
 * @param type - Typ nástroje.
 * @param position - Pozice nástroje.
 * @returns Definice nástroje.
 * @ignore
 */
function createFloatingTool(type: EditorToolType, position: FloatPosition): EditorToolDefinition {
    return {
        id: type + '_' + position,
        type,
        extend: true,
        float: position,
    };
}

export {EditorTool};
